"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabList = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var core_1 = require("@material-ui/core");
var TabList_style_1 = require("./TabList.style");
var TabList = function (_a) {
    var activeTab = _a.activeTab, handleChange = _a.handleChange, tabsInfo = _a.tabsInfo;
    var classes = (0, TabList_style_1.useTabsStyles)();
    return (react_1.default.createElement("div", { "data-signa": "tabs" },
        react_1.default.createElement(core_1.Tabs, { value: activeTab, onChange: handleChange, classes: { indicator: classes.indicator, flexContainer: classes.flexContainer } }, tabsInfo &&
            tabsInfo.map(function (tabInfo, index) { return (react_1.default.createElement(core_1.Tab, { label: tabInfo.label, disabled: tabInfo.isDisabled, classes: {
                    root: classes.root,
                    wrapper: classes.wrapper,
                    textColorInherit: classes.textColorInherit,
                    selected: classes.selected,
                    disabled: classes.disabled,
                }, icon: tabInfo.icon, "data-signa": "tab-".concat(index), key: "tab-".concat(index) })); }))));
};
exports.TabList = TabList;
